import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const LinesIcon = createIcon(
  'Lines',
  <path d="M3,9.03 C3,8.71 3.15,8.41 3.41,8.22 L7.14,5.5 C7.54,5.21 8.09,5.25 8.44,5.6 L12.22,9.38 L19.42,4.15 C20.07,3.67 21,4.14 21,4.96 C21,5.28 20.85,5.58 20.59,5.77 L12.69,11.5 C12.29,11.79 11.74,11.75 11.4,11.4 L7.62,7.62 L4.59,9.84 C3.93,10.32 3,9.85 3,9.03 Z M21,16 C21,15.45 20.55,15 20,15 L16.65,15 C16.42,15 16.2,15.08 16.03,15.22 L12.13,18.34 L6.6,12.99 C6.25,12.65 5.72,12.61 5.33,12.89 L3.43,14.24 C3.16,14.43 3,14.74 3,15.06 C3,15.87 3.92,16.35 4.58,15.87 L5.8,15 L11.37,20.39 C11.73,20.74 12.3,20.77 12.69,20.45 L17,17 L20,17 C20.55,17 21,16.55 21,16 Z" />
);

export default LinesIcon;
